import Node from './node';
import { CALENDAR_EVENT } from './nodetypes';

export default class CalendarMap extends Node {
  calendarEventsSelected = [];
  clone() {
    return new CalendarMap(this.text, this.attributes, this.children.map((c) => c.clone()), this.owner);
  }
  get calendarEvents() {
    return this.children.filter((_child) => _child.isType(CALENDAR_EVENT));
  }
  updateCalendarEventsSelected(_calendarEventsFound) {
    this.calendarEventsSelected = _calendarEventsFound;
    this.emitStateUpdate();
  }
}
